// Layout route that drives the i18n language from the URL prefix and keeps the
// per-language <html lang>, self-canonical, and hreflang alternates correct for
// JS-rendering crawlers (Google). JS-less AI crawlers get all of this from the
// static HTML prerendered by scripts/postbuild.mjs; this is the client-side mirror.
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import type { Lang } from '../lib/lang';
import { enPathOf } from '../lib/lang';
import { setLanguageLinks } from '../utils/seoHelper';

export default function LangLayout({ lang }: { lang: Lang }) {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  // URL is the source of truth for the content language.
  if ((i18n.language || 'en').split('-')[0] !== lang) {
    i18n.changeLanguage(lang);
  }

  // Runs after the page's own updatePageMeta (parent effect fires after child),
  // so the per-language canonical override wins.
  useEffect(() => {
    setLanguageLinks(lang, enPathOf(pathname));
  }, [lang, pathname]);

  return <Outlet />;
}
